import styled from '@emotion/styled'

const Section = styled.section`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;
    gap: 1rem;
`

export { Section }
